// Graph DB 챗 (QC 베타) — 모든 답변을 DeepSearch Graph DB(dskg_*) 도구만으로
// 만드는 전용 챗. Graph DB 담당자가 답변 품질을 점검하는 자리다.
//
// 킬스위치: 아래 상수를 false 로 내리면 사이드바 메뉴와 /graph-chat 진입 UI 가
// 함께 사라진다 (리포트 메뉴의 REPORT_ENABLED 와 같은 관행 — 서버 mode 분기는
// 남지만 부르는 곳이 없어 무해).
export const GRAPH_CHAT_ENABLED = true;

/** 대화 ID 프리픽스 — 이 프리픽스면 저장·복원·후속 턴 모두 dskg 모드로 돈다 */
export const GRAPH_CONV_PREFIX = "dskg:";

export const isGraphConv = (convId: string): boolean =>
  (convId || "").startsWith(GRAPH_CONV_PREFIX);

/** 웰컴 추천 질문 — Graph DB 강점 영역(그래프 관계·테마 검증·감정 시계열) 위주 */
export const GRAPH_CHIPS: string[] = [
  "삼성전자를 지배하는 지분 사슬을 보여줘",
  "HBM 테마로 실제 매출이 확인되는 회사를 골라줘",
  "최근 뉴스 감정이 급변한 종목 알려줘",
  "국민연금이 최근 지분을 늘린 종목은?",
  "에코프로 그룹 계열사 구조 보여줘",
  "카카오 주가 급등락 원인 짚어줘",
];
